module.exports = __webpack_public_path__ + "img/governor-horatio-seymour.1cf62c38.png";